/**
 * API Response Types
 *
 * Standard response formats for all API endpoints.
 * Uses discriminated unions for type-safe error handling.
 */
/**
 * Type guard to check if response is successful
 */
export function isApiSuccess(response) {
    return response.success === true;
}
/**
 * Type guard to check if response is an error
 */
export function isApiError(response) {
    return response.success === false;
}
/**
 * Common error codes
 */
export var ApiErrorCode;
(function (ApiErrorCode) {
    // Client errors (4xx)
    ApiErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ApiErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ApiErrorCode["CONFLICT"] = "CONFLICT";
    ApiErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ApiErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ApiErrorCode["BAD_REQUEST"] = "BAD_REQUEST";
    // Server errors (5xx)
    ApiErrorCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ApiErrorCode["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    // Business logic errors
    ApiErrorCode["ENTITY_IN_USE"] = "ENTITY_IN_USE";
    ApiErrorCode["DUPLICATE_ENTRY"] = "DUPLICATE_ENTRY";
    ApiErrorCode["INVALID_STATE"] = "INVALID_STATE";
})(ApiErrorCode || (ApiErrorCode = {}));
/**
 * Helper to create success response
 */
export function createSuccessResponse(data) {
    return { success: true, data };
}
/**
 * Helper to create error response
 */
export function createErrorResponse(error, details, code) {
    return { success: false, error, details, code };
}
//# sourceMappingURL=api.types.js.map